"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TargetsSensitiveTopicExclusionsToJSON = exports.TargetsSensitiveTopicExclusionsFromJSONTyped = exports.TargetsSensitiveTopicExclusionsFromJSON = exports.instanceOfTargetsSensitiveTopicExclusions = void 0;
var runtime_1 = require("../runtime");
var SensitiveTopicFilter_1 = require("./SensitiveTopicFilter");
var TargetsSensitiveTopicExclusionsTopicsInner_1 = require("./TargetsSensitiveTopicExclusionsTopicsInner");
/**
 * Check if a given object implements the TargetsSensitiveTopicExclusions interface.
 */
function instanceOfTargetsSensitiveTopicExclusions(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfTargetsSensitiveTopicExclusions = instanceOfTargetsSensitiveTopicExclusions;
function TargetsSensitiveTopicExclusionsFromJSON(json) {
    return TargetsSensitiveTopicExclusionsFromJSONTyped(json, false);
}
exports.TargetsSensitiveTopicExclusionsFromJSON = TargetsSensitiveTopicExclusionsFromJSON;
function TargetsSensitiveTopicExclusionsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'topics': !(0, runtime_1.exists)(json, 'topics') ? undefined : (json['topics'].map(TargetsSensitiveTopicExclusionsTopicsInner_1.TargetsSensitiveTopicExclusionsTopicsInnerFromJSON)),
        'filterOption': !(0, runtime_1.exists)(json, 'filter_option') ? undefined : (0, SensitiveTopicFilter_1.SensitiveTopicFilterFromJSON)(json['filter_option']),
    };
}
exports.TargetsSensitiveTopicExclusionsFromJSONTyped = TargetsSensitiveTopicExclusionsFromJSONTyped;
function TargetsSensitiveTopicExclusionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'topics': value.topics === undefined ? undefined : (value.topics.map(TargetsSensitiveTopicExclusionsTopicsInner_1.TargetsSensitiveTopicExclusionsTopicsInnerToJSON)),
        'filter_option': (0, SensitiveTopicFilter_1.SensitiveTopicFilterToJSON)(value.filterOption),
    };
}
exports.TargetsSensitiveTopicExclusionsToJSON = TargetsSensitiveTopicExclusionsToJSON;
